export const areaOptions = [
  "capital_delivery",
  "engineering_and_asset_management",
  "health_safety_and_environment",
  "investment_director",
  "maintenance_-_area_services",
  "maintenance_delivery",
  "operations_delivery",
  "planning",
  "planning_and_performance",
  "route_services",
  "safety_and_asset_management",
  "works_delivery",
];
